export * as category from '@wix/auto_sdk_faq_category/schemas';
export * as questionEntry from '@wix/auto_sdk_faq_question-entry/schemas';
